module.exports = __webpack_public_path__ + "static/media/login-girl.2bfec254.png";